export enum NetworkStateTypesEnum {
  Online = 'online',
  Offline = 'offline',
}
